import { Typography, Box, type BoxProps } from "@mui/material";
import React from "react";

import { ExternalLink } from "src/components/ExternalLink";
import { EmeriaUrl } from "src/constants";
import { useBrand } from "src/hooks/useBrand";

export const LegalInfo = (props: BoxProps) => {
  const { identity, dataProtectionPolicy } = useBrand();

  return (
    <Box {...props}>
      <Typography>
        Les données à caractère personnel recueillies par la société {identity.name}, filiale d'
        <ExternalLink href={EmeriaUrl}>Emeria Europe</ExternalLink>, responsable du traitement, font
        l'objet d'un traitement automatisé pour les besoins de la gestion de la relation client et
        la bonne exécution du contrat. Ces données sont destinées à{" "}
        <ExternalLink href={EmeriaUrl}>Emeria Europe</ExternalLink> et à ses filiales et seront
        conservées pour une durée maximale de 5 ans après la fin de la relation contractuelle,
        conformément à l'article 2224 du code civil et à l'article L561-12 du code monétaire et
        financier.
      </Typography>
      <Typography>
        Conformément à la loi n°78-17 du 6 janvier 1978 et au Règlement Général sur la Protection
        des Données (RGPD), vous disposez des droits d'accès, d'opposition, de rectification, de
        portabilité, de limitation et de suppression de vos données personnelles. Pour exercer ces
        droits, veuillez contacter le Délégué à la Protection des Données (DPO) du Groupe Emeria via{" "}
        <ExternalLink href={dataProtectionPolicy.formUrl}>
          le formulaire accessible ici
        </ExternalLink>
        . Pour plus d'information, consultez{" "}
        <ExternalLink href={dataProtectionPolicy.url}>
          notre politique sur la protection des données personnelles
        </ExternalLink>
        .
      </Typography>
      <Typography>
        {`${identity.name} : Société par actions simplifiée au capital de 282\u00A0364\u00A0800,00\u00A0€ dont le siège social est à Courbevoie (92400) - Tour Aurore, 18-19 place des Reflets, immatriculée au Registre du Commerce et des Sociétés de Nanterre sous le numéro 890\u00A0441\u00A0223.`}
      </Typography>
    </Box>
  );
};
